import React from 'react'
import { getHexColor, OneColorIconProps } from '@/atoms/utils'

export const BrokenImageIcon: React.FC<OneColorIconProps> = ({ size = 24, color = 'black', className }) => {
  const c1 = getHexColor(color)

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" className={className}>
      <path fill="none" d="M0 0h24v24H0V0z" />
      <path
        fill={c1}
        d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5v-4.58l.99.99 4-4 4 4 4-3.99L19 12.43V19zm0-9.41l-1.01-1.01-4 4.01-4-4-4 4-.99-1V5h14v4.59z"
      />
    </svg>
  )
}
